import React from 'react'
import Layout from '../common/Layout'

const Dashboard = () => {
  return (
    <>
        <Layout>
            <div class="content-wrapper">
                <div class="container-xxl flex-grow-1 container-p-y">
                    <div class="d-flex justify-content-between align-items-center py-3">
                    <h4 class="fw-bold py-3 mb-2"><span class="text-muted fw-light"><p className="breadcrumb-item active mb-0" aria-current="page">Dashboard</p></span></h4>
                    </div>
                </div>
            </div>
        </Layout>
    </>
  )
}

export default Dashboard
